export const BM_MODULE_NAMESPACE = 'bm'
export const BM_GET_BMS = 'BM_GET_BMS'
export const BM_GET_BM = 'BM_GET_BM'
export const BM_GET_BMS_LOADING = 'BM_GET_BMS_LOADING'
export const BM_GET_BM_LOADING = 'BM_GET_BM_LOADING'
export const BM_GET_BM_MEETINGS = 'BM_GET_BM_MEETINGS'
export const BM_GET_BM_MEETINGS_LOADING = 'BM_GET_BM_MEETINGS_LOADING'
export const BM_GET_MEETING = 'BM_GET_MEETING'
export const BM_GET_MEETING_PLAN = 'BM_GET_MEETING_PLAN'
export const BM_GET_MARKERS = 'BM_GET_MARKERS'
export const BM_GET_MEETING_LOADING = 'BM_GET_MEETING_LOADING'
export const BM_SET_VALUE_BY_FIELD = 'BM_SET_VALUE_BY_FIELD'
export const BM_MEETING_SET_VALUE_BY_FIELD = 'BM_MEETING_SET_VALUE_BY_FIELD'
export const BM_RESET_BMS = 'BM_RESET_BMS'
export const BM_RESET_BM_MEETINGS = 'BM_RESET_BM_MEETINGS'
export const BM_SET_LOADER_STATE = 'BM_SET_LOADER_STATE'
export const BM_ACTION = 'BM_ACTION'
export const BM_EDIT_BM = 'BM_EDIT_BM'
export const BM_EDIT_MEETING = 'BM_EDIT_MEETING'
export const BM_EDIT_BM_BY_FIELD = 'BM_EDIT_BM_BY_FIELD'
export const BM_EDIT_PARTICIPANT_BY_FIELD = 'BM_EDIT_PARTICIPANT_BY_FIELD'
export const BM_EDIT_MEETING_BY_FIELD = 'BM_EDIT_MEETING_BY_FIELD'
export const BM_EDIT_IB_BY_FIELD = 'BM_EDIT_IB_BY_FIELD'
export const BM_EDIT_PLAN_BY_FIELD = 'BM_EDIT_PLAN_BY_FIELD'
export const BM_EDIT_CONTRACTOR_BY_FIELD = 'BM_EDIT_CONTRACTOR_BY_FIELD'
export const BM_EDIT_COMMENT_BY_FIELD = 'BM_EDIT_COMMENT_BY_FIELD'
export const BM_EDIT_MARKER_BY_FIELD = 'BM_EDIT_MARKER_BY_FIELD'
export const BM_CREATE_BM = 'BM_CREATE_BM'
export const BM_CREATE_MEETING = 'BM_CREATE_MEETING'
export const BM_POST_BM = 'BM_POST_BM'
export const BM_POST_PARTICIPANT = 'BM_POST_PARTICIPANT'
export const BM_POST_MEETING = 'BM_POST_MEETING'
export const BM_POST_IB = 'BM_POST_IB'
export const BM_POST_PLAN = 'BM_POST_PLAN'
export const BM_POST_CONTRACTOR = 'BM_POST_CONTRACTOR'
export const BM_POST_COMMENT = 'BM_POST_COMMENT'
export const BM_POST_MEDIA = 'BM_POST_MEDIA'
export const BM_POST_MARKER = 'BM_POST_MARKER'
export const BM_PATCH_BM = 'BM_PATCH_BM'
export const BM_PATCH_PARTICIPANT = 'BM_PATCH_PARTICIPANT'
export const BM_PATCH_MEETING = 'BM_PATCH_MEETING'
export const BM_PATCH_IB = 'BM_PATCH_IB'
export const BM_PATCH_PLAN = 'BM_PATCH_PLAN'
export const BM_PATCH_CONTRACTOR = 'BM_PATCH_CONTRACTOR'
export const BM_PATCH_COMMENT = 'BM_PATCH_COMMENT'
export const BM_PATCH_MARKER = 'BM_PATCH_MARKER'
export const BM_DELETE_BM = 'BM_DELETE_BM'
export const BM_DELETE_MEETING = 'BM_DELETE_MEETING'
export const BM_DELETE_PARTICIPANT = 'BM_DELETE_PARTICIPANT'
export const BM_DELETE_IB = 'BM_DELETE_IB'
export const BM_DELETE_PLAN = 'BM_DELETE_PLAN'
export const BM_DELETE_CONTRACTOR = 'BM_DELETE_CONTRACTOR'
export const BM_DELETE_COMMENT = 'BM_DELETE_COMMENT'
export const BM_DELETE_MARKER = 'BM_DELETE_MARKER'
export const BM_ARCHIVE_BM = 'BM_ARCHIVE_BM'
export const BM_ARCHIVE_MEETING = 'BM_ARCHIVE_MEETING'
export const BM_OPEN_CLOSE_COMMENT = 'BM_OPEN_CLOSE_COMMENT'
export const BM_CURRENT_BM = 'BM_CURRENT_BM'
export const BM_DELETE_COMMENT_MEDIA = 'BM_DELETE_COMMENT_MEDIA'
export const BM_POST_COMMENT_MEDIA = 'BM_POST_COMMENT_MEDIA'
export const BM_GET_PLAN_BY_PARAMS = 'BM_GET_PLAN_BY_PARAMS'
export const BM_SAVE_DOCUMENT = 'BM_SAVE_DOCUMENT'
export const BM_GENERATE_REPORT = 'BM_GENERATE_REPORT'
export const BM_LOADERS = Object.freeze({
  LIST: 'BM_LIST',
  FILTERS: 'BM_FILTERS',
  SIDEBAR: 'BM_SIDEBAR',
  DETAILS: 'BM_DETAILS',
  PLANS: 'BM_PLANS'
})



// WEBPACK FOOTER //
// ./src/store/building-monitor/bm-types.store.ts